export default "__VITE_ASSET__Fnz0hC_W__"